import React from 'react';
import Avatar from '../Form/Avatar';
import UserInfo from '../Form/UserInfo';
import StarRating from '../Form/StarRating';

const ReviewCard = ({ profilePicture, userName, companyName, starRating, description }) => {
      // Get the first letter of the userName for the fallback profile picture

      return (
        <div className="w-full h-full p-5 bg-[#FFFFFF] border rounded-sm">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center space-x-3">
              {/* Profile Picture or First Letter */}
              <Avatar
                profilePicture={profilePicture}
                userName={userName || 'Unknown User'}
                size={48}
              />
              {/* User Info */}
              <UserInfo
                userName={userName || 'Unknown User'}
                companyName={companyName || 'Unknown Company'} 
              />   
            </div>
            {/* Star Rating */}
            <StarRating rating={starRating} size={20} loading={false} />
          </div>
          {/* Description */}
          <p className="font-normal text-content-text font-inter text-level-6">{description || 'No description provided.'}</p>
        </div>
      );
    };

export default ReviewCard;